
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductPartyDetailsDialog extends _Ext.ItemEditorDialog<ProductPartyDetailsRow> {
        protected getFormKey() { return ProductPartyDetailsForm.formKey; }
        protected getIdProperty() { return ProductPartyDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductPartyDetailsRow.localTextPrefix; } 

        protected form = new ProductPartyDetailsForm(this.idPrefix);

    }
}